import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { RecoilRoot } from 'recoil'
import { store, history } from '@app/store'
import Routes from '@app/router'
import { CopilotProvider } from '@components/shared/ChampCopilot/CopilotContext'
import '@assets/scss/style.scss'

class App extends Component {
  render() {
    return (
      <RecoilRoot>
        <Provider store={store}>
          {/* Copilot STATE lives here (persistent app shell) so it survives the
              per-route Layout remount; the VISIBLE FAB/window mount only inside
              the SMB Layout. The provider connects nothing on its own. */}
          <CopilotProvider>
            <Routes history={history} />
          </CopilotProvider>
        </Provider>
      </RecoilRoot>
    )
  }
}

export default App
